












import { Component, Vue } from 'vue-property-decorator';

import PlayButton from '@/components/PlayButton.vue';

import { addGtmEvent, GTMEvent } from '@/helpers/gtm';

@Component({
  components: { PlayButton },
})
export default class CoverCard extends Vue {
  handlePlayClick() {
    addGtmEvent(GTMEvent.LANDING_CLICK);
  }
}
